import * as views from './pages'

angular.module('app.financeiro').config(function ($stateProvider, lazyLoadProvider) {
    $stateProvider
        .state('app.financeiro', {
            abstract: true
        })
        .state('app.financeiro.bos', {
            abstract: true
        })
        .state('app.financeiro.parametros', {
            abstract: true
        })
        .state('app.financeiro.processos', {
            abstract: true
        })
        .state('app.financeiro.parametros.parametroBanco', {
            url: '/parametros/parametrobanco',
            views: {
                'content@app': lazyLoadProvider.create(views.parametros.parametroBanco)
            },
            data: {
                title: 'Parâmetro por Banco',
                access: { requiredPermissions: ['ParametroBanco'] },
                breadcrumbs: ['Parâmetro', 'Parâmetro por Banco']
            }
        })
        .state('app.financeiro.processos.baixaTituloManual', {
            url: '/processos/baixamanual',
            views: {
                'content@app': lazyLoadProvider.create(views.processos.baixaTituloManual)
            },
            data: {
                title: 'Baixa Título Manual',
                access: { requiredPermissions: ['RemessaBanco', 'backoffice'] },
                breadcrumbs: ['Processos', 'Baixa Título Manual']
            }
        })
        .state('app.financeiro.processos.retornoBancario', {
            url: '/processos/retorno',
            views: {
                'content@app': lazyLoadProvider.create(views.processos.retornoBancario)
            },
            data: {
                title: 'Retorno Bancário',
                access: { requiredPermissions: ['RemessaBanco', 'backoffice'] },
                breadcrumbs: ['Processos', 'Retorno Bancário']
            }
        })
        .state('app.financeiro.processos.baixaautomatica', {
            url: '/processos/baixaautomatica',
            views: {
                'content@app': lazyLoadProvider.create(views.processos.baixaTituloAutomatica)
            },
            data: {
                title: 'Baixa Título Automática',
                access: { requiredPermissions: ['RemessaBanco', 'backoffice'] },
                breadcrumbs: ['Processos', 'Baixa Título Automática']
            }
        })
        .state('app.financeiro.bos.remessaPagamento', {
            url: '/bos/remessapagamento',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.remessaPagamento)
            },
            data: {
                title: 'Remessa Pagamento',
                access: { requiredPermissions: ['RemessaPagamento'] },
                breadcrumbs: ['BOS', 'Remessa Pagamento']
            }
        })
        .state('app.financeiro.bos.remessaPagamentoEdit', {
            url: '/bos/remessabanco/edit',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.remessaPagamentoEdit)
            },
            data: {
                title: 'Montar Remessa Pagamento',
                access: { requiredPermissions: ['RemessaPagamento'] },
                breadcrumbs: ['BOS', 'Remessa Pagamento', 'Montar']
            }
        })
        .state('app.financeiro.bos.remessaPagamentoFinalizacao', {
            url: '/bos/remessabanco/finalizacao',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.remessaPagamentoFinalizacao)
            },
            data: {
                title: 'Finalização Remessa Pagamento',
                access: { requiredPermissions: ['RemessaPagamento'] },
                breadcrumbs: ['BOS', 'Remessa Pagamento', 'Finalizar']
            }
        })
        .state('app.financeiro.bos.situacaoPagamentoAutomatico', {
            url: '/bos/situacaoPagamentoAutomatico',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.situacaoPagamentoAutomatico)
            },
            data: {
                title: 'Situação Pagamento Automático',
                access: { requiredPermissions: ['RemessaPagamento', 'backoffice'] },
                breadcrumbs: ['BOS', 'Situação Pagamento Automático']
            }
        })
        .state('app.financeiro.processos.liquidacaoAutomatica', {
            url: '/processos/liquidacaoautomatica',
            views: {
                'content@app': lazyLoadProvider.create(views.processos.liquidacaoAutomatica)
            },
            data: {
                title: 'Liquidação Automática',
                access: { requiredPermissions: ['RemessaBanco', 'backoffice'] },
                breadcrumbs: ['Processos', 'Liquidação Automática']
            }
        })
        .state('app.financeiro.bos.tempoDesembolso', {
            url: '/bos/tempoDesembolso',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.tempoDesembolso)
            },
            data: {
                title: 'Tempo de Desembolso',
                access: { requiredPermissions: ['RemessaPagamento', 'backoffice'] },
                breadcrumbs: ['BOS', 'Tempo de Desembolso']
            }
        })
        .state('app.financeiro.bos.outrosPagamentos', {
            url: '/bos/outrospagamentos',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.outrosPagamentos)
            },
            data: {
                title: 'Outros Pagamentos',
                access: { requiredPermissions: ['RemessaFundo', 'backoffice'] },
                breadcrumbs: ['BOS', 'Outros Pagamentos']
            }
        })
        .state('app.financeiro.bos.estornoPagamentoAutomatico', {
            url: '/bos/estornointegracaodbs',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.estornoPagamentoAutomatico)
            },
            data: {
                title: 'Estorno Pagamento Automático',
                access: { requiredPermissions: ['RemessaPagamento'] },
                breadcrumbs: ['BOS', 'Estorno Pagamento Automático']
            }
        })
        .state('app.financeiro.pagamento', {
            abstract: true
        })
        .state('app.financeiro.pagamento.propostas', {
            url: '/processos/propostafinanceiro',
            views: {
                'content@app': lazyLoadProvider.create(views.pagamento.propostas)
            },
            data: {
                title: 'Pagamento',
                access: { requiredPermissions: ['PropostaFinanceiro'] },
                breadcrumbs: ['Processos', 'Propostas em Pagamento']
            }
        })
        .state('app.financeiro.pagamento.propostasEdit', {
            url: '/processos/proposta/financeiro',
            views: {
                'content@app': lazyLoadProvider.create(views.pagamento.propostasEdit)
            },
            data: {
                title: 'Pagar Proposta',
                access: { requiredPermissions: ['PropostaFinanceiro'] },
                breadcrumbs: ['Processos', 'Proposta', 'Pagar']
            }
        })
        .state('app.financeiro.bos.comprovantePagamento', {
            url: '/bos/comprovantepagamento',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.comprovantePagamento)
            },
            data: {
                title: 'Comprovantes de Pagamento',
                access: { requiredPermissions: ['RemessaFundo', 'backoffice'] },
                breadcrumbs: ['BOS', 'Comprovantes de Pagamento']
            }
        })
        .state('app.financeiro.bos.comprovantePagamentoVisualizar', {
            url: '/bos/comprovantepagamentovisualizar',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.comprovantePagamentoVisualizar)
            },
            data: {
                title: 'Comprovante de Pagamento',
                access: { requiredPermissions: ['RemessaFundo', 'backoffice'] },
                breadcrumbs: ['BOS', 'Comprovante de Pagamento', 'Visualizar']
            }
        })

        .state('app.financeiro.bos.retornoPagamentoBanco', {
            url: '/bos/retornopagamentobanco',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.retornoDeRemessa)
            },
            data: {
                title: 'Retorno Pagamento',
                access: { requiredPermissions: ['RemessaPagamento'] },
                breadcrumbs: ['BOS', 'Retorno da Remessa de Pagamento']
            }
        })
        .state('app.financeiro.processos.remessaBanco', {
            url: '/processos/remessa',
            views: {
                'content@app': lazyLoadProvider.create(views.processos.remessaBanco)
            },
            data: {
                title: 'Remessa Bancária',
                access: { requiredPermissions: ['RemessaBanco', 'backoffice'] },
                breadcrumbs: ['Processos', 'Remessa Bancária']
            }
        })
});
